/**
 * College Auth Service
 * User authentication utilities
 */

import { supabase } from "../../lib/supabase";
import { getStudentIdFromAuth } from "./favorites";
import { getErrorMessage } from "../../utils/errorUtils";

// ============================================
// User Types
// ============================================

export interface CurrentUser {
  id: string;
  email: string | undefined;
  metadata: Record<string, unknown>;
  studentId: string | null;
}

// ============================================
// Auth Functions
// ============================================

/**
 * Get current logged-in user with student profile
 */
export async function getCurrentUser(): Promise<CurrentUser | null> {
  try {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();

    if (error) {
      throw new Error(`Failed to get current user: ${error.message}`);
    }

    if (!user) {
      return null;
    }

    // Get student profile if exists
    const studentId = await getStudentIdFromAuth(user.id).catch(() => null);

    return {
      id: user.id,
      email: user.email,
      metadata: user.user_metadata || {},
      studentId: studentId,
    };
  } catch (error: unknown) {
    console.error("Error in getCurrentUser:", getErrorMessage(error));
    throw error;
  }
}
